// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3Gcql","question":"Question_question__1gdSE","description":"Question_description__32YRl"};